import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import endPoint from "../EndPoint/endpoint";

export const AddWishlist = createAsyncThunk(
  "wishList/addWishlist",
  async (productId, thunkAPI) => {
    try {
      const storedUuid = localStorage.getItem("uuid");
      const Token = localStorage.getItem("loginData");

      const response = await axios.post(
        endPoint.ADDWISHLIST,
        { productId: productId },
        {
          headers: {
            sessionId: storedUuid ? storedUuid : "",
            Authorization: Token ? `Bearer ${Token}` : "",
          },
        }
      );
      return response?.data;
    } catch (error) {
      console.error("Error Details:", error.response?.data || error.message);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const AddWishlistSlice = createSlice({
  name: "WishList",
  initialState: {
    WishList: [],
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(AddWishlist.fulfilled, (state, action) => {
        state.WishList = action.payload;
      })
      .addCase(AddWishlist.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export default AddWishlistSlice.reducer;
